<div class="row_1">
   <div class="top_grid_agg">
        <div class="content">
          <div style="width: 50%; justify-content: left; display: flex;">
            <button routerLink="/board" class="back_button">BACK</button>
        
          </div>
        </div>
        <div class="grid-agg">
          <div class="row">
            <div  class="col-md-6 grid">
                <div  class="col-md-12 offset-3 "  routerLink="/createperiod">
                     <p class="heading" >NEW PERIOD TASK</p>
                     <p class="description">Create a task specific to a d-day and period</p>
                 </div>
                 <div  class="col-md-12 offset-3 "  routerLink="/createonetime">
                    <p class="heading">NEW ONE-TIME TASK</p>   
                    <p class="description">Create a new board task for a specific day and time</p> 
                </div>
                <div routerLink="/newcontingency" class="col-md-12 offset-3">
                    <p class="heading" >NEW CONTINGENCY TASK</p>    
                    <p class="description">Create a new board task for a specific day and time</p>   
                 </div>
                 <div routerLink="/weeklytask"  class="col-md-12  offset-3">
                    <p class="heading" >NEW WEEKLY TASK </p>       
                    <p class="description">Create a new board task which repeat weekly on specific -days</p> 
                 </div>
            </div>  
            <div  class="col-md-6 grid">
                <div  class="col-md-12" routerLink="/createmonthlytask">
                    <p class="heading">NEW MONTHLY TASK</p> 
                    <p class="description">Create a new board task which repeat weekly on specific day of each month or a pettern</p>                 
                </div>
                <div  routerLink="/createfromtemplate" class="col-md-12">
                  <p class="heading" >CREATE FROM TEMPLATE</p>  
                  <p class="description">Depoly a group of related task (e.g. periods, projects, etc.)</p> 
                   </div>
                   <div routerLink="/createcontingency"  class=" col-md-12 ">
                    <p class="heading" >CREATE CONTINGENCY </p>       
                    <p  class="description">This task will create contingency based on a predefined set of task codes & days. The user will choose the day of contingency & all task will be assigned the appropriate due dates</p>       
                   </div>
              </div>
              </div> 
       </div>
    </div> 
</div>




  
  